import { mapActions, mapGetters } from 'vuex';
import pinIcon from './pin-icon.vue';
import unpinIcon from './unpin-icon.vue';
import pinSettingsToggleIcon from './pin-settings-toggle-icon.vue';

const PIN_CYCLE = ['left', 'right'];

function nextPinState(current, side) {
  if (side === 'left') return current === 'left' ? null : 'left';
  if (side === 'right') return current === 'right' ? null : 'right';
  if (!current) return 'left';
  const idx = PIN_CYCLE.indexOf(current);
  return idx === PIN_CYCLE.length - 1 ? null : PIN_CYCLE[idx + 1];
}

const ICON_TITLES = {
  toLeft: label => `Pin ${label} to the left`,
  switchToRight: label => `Switch ${label} to the right panel`,
  unpin: label => `Unpin ${label}`,
};

export default {
  components: { pinIcon, unpinIcon, pinSettingsToggleIcon },
  props: {
    menu: {
      type: Array,
      required: true,
    },
    side: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return {
      showMenu: false,
      hoveredKey: null,
    };
  },
  created() {
    this.pinSettingsOpenedHandler = (uid) => {
      if (uid !== this._uid) this.showMenu = false;
    };
    this.$root.$on('pin-settings-opened', this.pinSettingsOpenedHandler);
  },
  beforeDestroy() {
    this.$root.$off('pin-settings-opened', this.pinSettingsOpenedHandler);
  },
  computed: {
    ...mapGetters('pinning', ['getPinnedPanel']),
    menuHeader() {
      return this.side === 'right' ? 'Secondary Tray Widgets' : 'Primary Tray Widgets';
    },
  },
  methods: {
    ...mapActions('pinning', ['togglePin']),

    toggleMenu() {
      this.showMenu = !this.showMenu;
      if (this.showMenu) this.$root.$emit('pin-settings-opened', this._uid);
    },

    pinnedSide(widget) {
      return this.getPinnedPanel(widget);
    },

    setHover(widget) {
      this.hoveredKey = widget;
    },

    clearHover() {
      this.hoveredKey = null;
    },

    isUnpinPreview(item) {
      return this.hoveredKey === item.widget
        && nextPinState(this.pinnedSide(item.widget), item.side || 'left') === null;
    },

    itemRowClass(item) {
      return {
        'pin-settings__item-row': true,
        'pin-settings__item-row--pinned': this.pinnedSide(item.widget) === item.side,
      };
    },

    labelClass(item) {
      return {
        'pin-settings__item-label': true,
        'pin-settings__item-label--pinned': this.pinnedSide(item.widget) === item.side,
      };
    },

    iconTitle(item) {
      const next = nextPinState(this.pinnedSide(item.widget), item.side || 'left');
      if (next === 'left') return ICON_TITLES.toLeft(item.label);
      if (next === 'right') return ICON_TITLES.switchToRight(item.label);
      return ICON_TITLES.unpin(item.label);
    },

    handleIconClick(item) {
      const current = this.pinnedSide(item.widget);
      const next = nextPinState(current, item.side || 'left');
      const panel = next || current;
      this.togglePin({ widget: item.widget, panel });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pinning/pin-settings/pin-settings.js